import React, { useContext } from 'react';
import { FaFacebookSquare } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { CursorContext } from '../context/CursorContext';
import { useTheme } from '../context/ThemeContext';

const Socialmedia = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const theme = useTheme();
  const darkMode = theme?.darkMode ?? true;

  const iconColor = darkMode ? 'text-gray-200' : 'text-slate-900';

  return (
    <div
      onMouseEnter={mouseEnterHandler}
      onMouseLeave={mouseLeaveHandler}
      className='sm:mx xl:flex'
    >
      <ul className={`flex gap-x-4 ${iconColor}`}>
        <li>
          <a href='http://www.edenhailemariam01@gmail.com' target='_blank' rel="noreferrer" className="hover:opacity-50 transition">
            <MdEmail size={20} />
          </a>
        </li>
        <li>
          <a href='http://www.instagram.com/edclear/' target='_blank' rel="noreferrer" className="hover:opacity-50 transition">
            <FaSquareInstagram size={20} />
          </a>
        </li>
        <li>
          <a href='http://www.facebook.com/EdenKefaleGebreyes/' target='_blank' rel="noreferrer" className="hover:opacity-50 transition">
            <FaFacebookSquare size={19} />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Socialmedia;